{
 "_": "v245 THE ACADEMY (src/academy.js). Four opt-in lessons on the REAL engine: each is a campaign-style level record (existing knobs only: D, aiHp, aiDmg, maxRounds + its patternSeed, which alone scripts the foe's intents) and a loaner squad (no WARD: its cancelIntent rewrites the scripted intents; no PIERCE/SWIFT: they bypass the SHIELD / the pip cost a lesson teaches). `ai` = the AI-side beats scripts/academy-gate.mjs asserts for every attempt seed (intent[r] = the foe's intent in round r, 0-based). patternSeed is found by scripts/academy-seeds.mjs. Words on screen come from src/academy.js (numbers read live from CARD_RULES).",
 "squad": [
  "stone-cold-david",
  "the-crane-shot",
  "fallooman",
  "the-abiding",
  "dorian-hayley"
 ],
 "foe": [
  "cyclops-baiter",
  "cryofry",
  "mistveil",
  "verismo",
  "canyonfluencer"
 ],
 "lessons": [
  {
   "id": "A1",
   "title": "Intent & Blocking",
   "goal": "Shatter the SHIELD",
   "challenge": "shatter",
   "ai": {
    "intent": [
     "STRIKE",
     "SHIELD",
     "CHARGE"
    ]
   },
   "rec": {
    "id": "A1",
    "kind": "academy",
    "D": 0,
    "arena": null,
    "twist": null,
    "maxRounds": 8,
    "patternSeed": 1007,
    "knobs": {
     "aiHp": 3000,
     "aiDmg": 30
    }
   }
  },
  {
   "id": "A2",
   "title": "Pips & Swaps",
   "goal": "Swap out before the CHARGE",
   "challenge": "swap",
   "ai": {
    "intent": [
     "STRIKE",
     "CHARGE"
    ]
   },
   "rec": {
    "id": "A2",
    "kind": "academy",
    "D": 0,
    "arena": null,
    "twist": null,
    "maxRounds": 8,
    "patternSeed": 1000,
    "knobs": {
     "aiHp": 3000,
     "aiDmg": 30
    }
   }
  },
  {
   "id": "A3",
   "title": "Types",
   "goal": "Win with the counter leading",
   "challenge": "typewin",
   "ai": {
    "intent": [
     "STRIKE",
     "STRIKE"
    ]
   },
   "rec": {
    "id": "A3",
    "kind": "academy",
    "D": 0,
    "arena": null,
    "twist": null,
    "maxRounds": 8,
    "patternSeed": 1028,
    "knobs": {
     "aiHp": 70,
     "aiDmg": 30
    }
   }
  },
  {
   "id": "A4",
   "title": "Signatures & Captain",
   "goal": "Land a PERFECT closer",
   "challenge": "perfectsig",
   "captain": "stone-cold-david",
   "ai": {
    "intent": [
     "STRIKE",
     "STRIKE"
    ]
   },
   "rec": {
    "id": "A4",
    "kind": "academy",
    "D": 0,
    "arena": null,
    "twist": null,
    "maxRounds": 8,
    "patternSeed": 1028,
    "knobs": {
     "aiHp": 3000,
     "aiDmg": 30
    }
   }
  }
 ]
}
